"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpairTerminal = exports.updateTerminalInfo = exports.getTerminals = exports.getTerminal = exports.asyncPairTerminal = exports.getConnectionStatus = void 0;
const shared_1 = require("@getgreenline/shared");
const setBaseUrl = ({ tenantId, retailerId }) => {
    return `${shared_1.WORLDPAY_API_URL}/worldpay/tenants/${tenantId}/retailers/${retailerId}/connections`;
};
const getConnectionStatus = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { connectionId } = params, restOfParams = __rest(params, ["connectionId"]);
    const apiUrl = `${setBaseUrl(restOfParams)}/${connectionId}/status`;
    const res = yield shared_1.axios.get(apiUrl);
    return res.data;
});
exports.getConnectionStatus = getConnectionStatus;
const asyncPairTerminal = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { payload } = params, restOfParams = __rest(params, ["payload"]);
    const apiUrl = setBaseUrl(restOfParams);
    const res = yield shared_1.axios.post(apiUrl, payload);
    return res.data;
});
exports.asyncPairTerminal = asyncPairTerminal;
const getTerminal = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { connectionId } = params, restOfParams = __rest(params, ["connectionId"]);
    const apiUrl = `${setBaseUrl(restOfParams)}/${connectionId}`;
    const res = yield shared_1.axios.get(apiUrl);
    const statusCode = res.status;
    return Object.assign({ statusCode }, res.data);
});
exports.getTerminal = getTerminal;
const getTerminals = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const apiUrl = setBaseUrl(params);
    const res = yield shared_1.axios.get(apiUrl);
    return res.data;
});
exports.getTerminals = getTerminals;
const updateTerminalInfo = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { connectionId, payload } = params, restOfParams = __rest(params, ["connectionId", "payload"]);
    const apiUrl = `${setBaseUrl(restOfParams)}/${connectionId}`;
    const res = yield shared_1.axios.patch(apiUrl, payload);
    return res.data;
});
exports.updateTerminalInfo = updateTerminalInfo;
const unpairTerminal = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { connectionId } = params, restOfParams = __rest(params, ["connectionId"]);
    const apiUrl = `${setBaseUrl(restOfParams)}/${connectionId}`;
    const res = yield shared_1.axios.delete(apiUrl);
    return res.data;
});
exports.unpairTerminal = unpairTerminal;
//# sourceMappingURL=WorldpayTerminalAPI.js.map